var map = {
	"./Image 1.png": 475,
	"./arifwala-dark.png": 476,
	"./arifwala.png": 477,
	"./assign-icon.png": 478,
	"./bahawalnagar-dark.png": 479,
	"./bahawalnagar.png": 480,
	"./bhalwal-dark.png": 481,
	"./bhalwal.png": 482,
	"./burewala-dark.png": 483,
	"./burewala.png": 484,
	"./cell.png": 485,
	"./clhs-logo-light.png": 212,
	"./collection-center.png": 486,
	"./comment-img.png": 369,
	"./dera ghazi khan-dark.png": 487,
	"./dera ghazi khan.png": 488,
	"./error-icon.png": 213,
	"./graphic.png": 489,
	"./gujrat-dark.png": 490,
	"./gujrat.png": 491,
	"./icon1-d.png": 492,
	"./icon1.png": 493,
	"./icon2-d.png": 494,
	"./icon2.png": 305,
	"./icon3-d.png": 495,
	"./icon3.png": 496,
	"./icon4-d.png": 497,
	"./icon4.png": 498,
	"./icon5-d.png": 499,
	"./icon5.png": 500,
	"./icon6-d.png": 501,
	"./icon6.png": 502,
	"./icon7-d.png": 503,
	"./icon7.png": 504,
	"./img-1.png": 279,
	"./img.png": 505,
	"./kasur-dark.png": 506,
	"./kasur.png": 507,
	"./khanewal-dark.png": 508,
	"./khanewal.png": 509,
	"./kharian-dark.png": 510,
	"./kharian.png": 511,
	"./lalamusa-dark.png": 512,
	"./lalamusa.png": 513,
	"./larkana-dark.png": 514,
	"./larkana.png": 515,
	"./layyah-dark.png": 516,
	"./layyah.png": 517,
	"./loction-icon.png": 306,
	"./logo.png": 518,
	"./logo2.png": 161,
	"./man.png": 370,
	"./mandi bahauddin-dark.png": 519,
	"./mandi bahauddin.png": 520,
	"./mianwali-dark.png": 521,
	"./mianwali.png": 522,
	"./muzaffargarh-dark.png": 523,
	"./muzaffargarh.png": 524,
	"./no-patient-selected.png": 371,
	"./no-test.png": 209,
	"./okara-dark.png": 525,
	"./okara.png": 526,
	"./phalia-dark.png": 527,
	"./phalia.png": 528,
	"./quetta-dark.png": 529,
	"./quetta.png": 530,
	"./rahim yar khan-dark.png": 531,
	"./rahim yar khan.png": 532,
	"./re-assignment.png": 307,
	"./refresh-white.png": 55,
	"./refresh.png": 533,
	"./sahiwal-dark.png": 534,
	"./sahiwal.png": 535,
	"./sargodha-dark.png": 536,
	"./sargodha.png": 537,
	"./spot.png": 538,
	"./toba tek singh-dark.png": 539,
	"./toba tek singh.png": 540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;